<script>
    import { onMount, onDestroy } from 'svelte';
  
    let inactivityModal;
    let inactivityTimeout;
    let isUserLoggedIn = false;
    let logoutTimeout;

    const showModalSeconds =  window.inactivityModal.showModal;
    const autoLogoutSeconds = window.inactivityModal.logoutAfterWarning;

    // Function to reset the inactivity timer
    function resetInactivityTimer() {
      clearTimeout(inactivityTimeout);
      if (isUserLoggedIn) {
        inactivityTimeout = setTimeout(() => {
          if (inactivityModal) {
            inactivityModal.style.display = "block";
            logoutTimeout = setTimeout(() => {
              window.location.href = "/logout";
            }, autoLogoutSeconds); // 5 seconds
          }
        }, showModalSeconds); // 5 seconds
      }
    }
  
    // Function to setup activity triggers
    function setupActivityTriggers() {
      // Mouse, keyboard, scroll, and touch activity
      const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'touchmove'];
      events.forEach(event => {
        document.addEventListener(event, resetInactivityTimer, false);
      });
  
      // Cleanup function
      return () => {
        events.forEach(event => {
          document.removeEventListener(event, resetInactivityTimer, false);
        });
      };
    }
  
    // Check if user is logged in
    function checkUserLogin() {
      const logoutLink = document.querySelector('a[href="/logout"]');
      isUserLoggedIn = !!logoutLink;
      resetInactivityTimer();
    }
  
    onMount(() => {
      checkUserLogin();
      const cleanup = setupActivityTriggers();
      return cleanup;
    });
  </script>
  
  <div
    bind:this={inactivityModal}
    style="display: none;"
    class="modal"
  >
    <div class="modal-content">
        <h1>
            You are about to be logged out
        </h1>
        <hr/>
      <p>
        You will soon be logged out. Once logged out you will be taken back to the home page. To stay logged in click the button below.
      </p>
      <hr/>
      <button
      class="btn btn-lg btn-primary"
      on:click={() => {
        clearTimeout(logoutTimeout);
        inactivityModal.style.display = "none";
      }}>KEEP ME LOGGED IN</button>
    </div>
  </div>

<style>
  /* The Modal (background) */
  .modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.7);
    z-index:11111111;
  }

  /* Modal Content */
  .modal-content {
    display: grid;
    grid-auto-flow: row;
    position: relative;
    padding: 20px 0px;
    background-color: #ffffff;
    margin: 10% auto;
    width: 50%;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.3);

  }

  h1, p, button {
    margin: 0px 20px;
  }

  button{
    justify-self: end;
  }

  hr{
    margin: 15px 0px !important
  }
</style>
